<div class="container-fluid" *ngIf="item">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <h4 class="mb-sm-0">Corporate Deals Management</h4>
        <div class="page-title-right">
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item"><a routerLink="/dashboard">Menu</a></li>
            <li class="breadcrumb-item"><a routerLink="/ecomm/corporate-deals">Corporate Deals</a></li>
            <li class="breadcrumb-item active">{{ isEditMode ? 'Edit' : 'View' }}</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">{{ isEditMode ? 'Edit Corporate Deal' : 'Corporate Deal Details' }}</h4>
          <div class="flex-shrink-0">
            <a routerLink="/ecomm/corporate-deals" class="btn btn-light me-2">Back to List</a>
            <ng-container *ngIf="!isEditMode">
              <button type="button" class="btn btn-primary" (click)="startEdit()">Edit</button>
            </ng-container>
            <ng-container *ngIf="isEditMode">
              <button type="button" class="btn btn-light me-2" (click)="cancelEdit()">Back</button>
              <button type="button" class="btn btn-primary" (click)="save()">Save</button>
            </ng-container>
          </div>
        </div>
        <div class="card-body">
          <div class="row gy-4" *ngIf="!isEditMode">
            <div class="col-xxl-6 col-md-6"><label class="form-label">Partner ID</label><input class="form-control" [value]="item.partner_id" readonly></div>
            <div class="col-xxl-6 col-md-6"><label class="form-label">Corporate ID</label><input class="form-control" [value]="item.corporate_id ?? '-'" readonly></div>
            <div class="col-xxl-6 col-md-6"><label class="form-label">Name</label><input class="form-control" [value]="item.name" readonly></div>
            <div class="col-xxl-6 col-md-6"><label class="form-label">Countdown Minutes</label><input class="form-control" [value]="item.countdown_minutes" readonly></div>
            <div class="col-xxl-6 col-md-6"><label class="form-label">Status</label><input class="form-control" [value]="statusLabel(item.status)" readonly></div>
          </div>

          <div class="row gy-4" *ngIf="isEditMode">
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Partner ID <span class="text-danger">*</span></label>
              <input type="text" class="form-control" name="partner_id" [(ngModel)]="form.partner_id"
                     [ngClass]="{'is-invalid': !form.partner_id && validationTriggered}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Corporate ID</label>
              <input class="form-control" name="corporate_id" [(ngModel)]="form.corporate_id">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Name <span class="text-danger">*</span></label>
              <input class="form-control" name="name" [(ngModel)]="form.name" [ngClass]="{'is-invalid': !form.name && validationTriggered}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Countdown Minutes <span class="text-danger">*</span></label>
              <input type="text" inputmode="numeric" pattern="[0-9]*" class="form-control" name="countdown_minutes"
                     [(ngModel)]="form.countdown_minutes" (input)="onCountdownMinutesInput($event)"
                     [ngClass]="{'is-invalid': (form.countdown_minutes === '' || form.countdown_minutes === null) && validationTriggered}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Status <span class="text-danger">*</span></label>
              <select class="form-select" name="status" [(ngModel)]="form.status">
                <option [ngValue]="1">Active</option>
                <option [ngValue]="2">Inactive</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
